import Link from 'next/link';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center gap-2 mb-4 font-['IBM_Plex_Sans',system-ui,sans-serif] text-[12px] text-[#6B6B6B]" aria-label="Breadcrumb">
      {items.map((item, i) => (
        <span key={item.label} className="flex items-center gap-2">
          {item.href ? (
            <Link href={item.href} className="hover:text-[#0D0D0D] transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-[#0D0D0D]">{item.label}</span>
          )}
          {i < items.length - 1 && <span className="text-[#D4D4D4]">/</span>}
        </span>
      ))}
    </nav>
  );
}
